import React, { Component } from 'react';
import AdminHeader from '../Header/AdminHeader';
import AdminFooter from '../Footer/AdminFooter';
import AdminLeftMenu from '../Navbar/AdminLeftMenu';
import EmptyImg from "../Dashboard/assets/img/create-project.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faSearch } from '@fortawesome/free-solid-svg-icons';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { userloginDetails } from '../Utils/AdminAuth';
import { HOST_URL, NODE_HOST_URL } from '../Dashboard/api/Api';
import Spining from "../UI/Spining/Spining";
import Axios from '../../axios/Axios';

class ResellerTransactionHistory extends Component {

    constructor() {

        const lStorage = userloginDetails();
        const userId = lStorage?.user?.userId;
        const userToken = lStorage?.token;
        const isAdmin = lStorage?.user?.isAdmin;
        var today = new Date(),
            date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + ("0" + today.getDate()).slice(-2);

        super();
        this.state = {
            user_id: userId,
            userType: isAdmin,
            token: userToken,
            dateFrom: "",
            dateTo: "",
            allTransactionList: null,
            serchData: '',
            successMessage: false,
            errorMessage: '',
            bgColor: '',
            isLoading: false,
            page: 1,
            showPages: false,
            totalPages: 0
        }

    }

    componentDidMount() {
        this.onserch();
    }

    // onserch() {
    //     this.setState({ isLoading: true })
    //     fetch(`${HOST_URL}/transaction_history.php?user_id=${this.state.user_id}&method=transaction_history&type=${this.state.userType}&token=${this.state.token}`).then((response) => {
    //         response.json().then((result) => {
    //             // console.log(result)
    //             if (result.success === true) {
    //                 this.setState({ allTransactionList: result });
    //                 this.setState({ isLoading: false })
    //             } else {
    //                 this.setState({
    //                     successMessage: true,
    //                     successBg: "alert alert-danger alert-dismissible",
    //                     errorMessage: result.message
    //                 })
    //             }
    //         })
    //     })
    // }

    formatDate = (inputDate) => {
        const date = new Date(inputDate);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    showPagesOption = () => {
        this.setState({ showPages: true })
        this.onserch();
    }

    onserch = async (pageCount) => {
        this.setState({ isLoading: true });
        let paramData = {
            user_id: this.state.user_id,
            token: this.state.token,
            method: "transation_history",
            search: this.state.serchData,
            page: pageCount,
            from_date: this.state.dateFrom ? this.formatDate(this.state.dateFrom) : "",
            to_date: this.state.dateTo ? this.formatDate(this.state.dateTo) : "",
            filter: "self"
        }

        try {
            let { data } = await Axios.post(`${NODE_HOST_URL}/user`, paramData)
            if (data.success) {
                this.setState({ allTransactionList: data.data, totalPages: data.total_page });
            }
            else {
                this.setState({
                    successMessage: true,
                    successBg: "alert alert-danger alert-dismissible",
                    errorMessage: data.message
                })
            }
        } catch (error) {
            this.setState({
                successMessage: true,
                successBg: "alert alert-danger alert-dismissible",
                errorMessage: error.message
            })
        }
        finally {
            setTimeout(() => {
                this.setState({ successMessage: false });
            })
            this.setState({ isLoading: false });
        }

    }

    searchUser() {
        if (this.state.serchData === '') {
            this.onserch();
            this.setState({
                successMessage: true,
                errorMessage: "Enter User Name ",
                bgColor: "alert alert-danger alert-dismissible"
            });
        } else {
            const payload = {
                user_id: this.state.user_id,
                method: "transaction_history",
                type: this.state.userType,
                keyword: this.state.serchData,
                token: this.state.token,
            };

            fetch(`${HOST_URL}/transaction_history.php`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.success === true) {
                        this.setState({
                            successMessage: false,
                            allTransactionList: result
                        });
                    } else {
                        this.setState({
                            successMessage: true,
                            errorMessage: result.message,
                            bgColor: "alert alert-danger alert-dismissible"
                        });
                    }
                })
                .catch((error) => {
                    console.error("Error in searchUser:", error);
                });
        }
    }

    searchWithDate() {
        const payload = {
            user_id: this.state.user_id,
            method: "transaction_history",
            type: this.state.userType,
            keyword: this.state.serchData,
            token: this.state.token,
            from_date: this.state.dateFrom,
            to_date: this.state.dateTo,
        };

        fetch(`${HOST_URL}/transaction_history.php`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.success === true) {
                    this.setState({
                        successMessage: false,
                        errorMessage: "Result Updated",
                        allTransactionList: result
                    });
                } else {
                    this.setState({
                        successMessage: true,
                        errorMessage: result.message,
                        bgColor: "alert alert-danger alert-dismissible"
                    });
                }
            })
            .catch((error) => {
                console.error("Error in searchWithDate:", error);
            });
    }


    dateFrom = (date) => {
        let dated = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + ("0" + date.getDate()).slice(-2);
        this.setState({
            dateFrom: dated,
            SelecteddateFrom: date
        });
    };

    dateTo = (date) => {
        let dated = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + ("0" + date.getDate()).slice(-2);
        this.setState({
            dateTo: dated,
            SelecteddateTo: date
        });
    };

    previousPage = () => {
        let pageData = this.state.page - 1
        this.setState({ page: pageData })
        this.onserch(pageData)
    }

    nextPage = () => {
        let pageData = this.state.page + 1
        this.setState({ page: pageData })
        this.onserch(pageData)
    }

    formatToLocalDate = (dateString) => {
        const date = new Date(dateString);

        return new Intl.DateTimeFormat('en-IN', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            // timeZoneName: 'short'
        }).format(date);
    };




    render() {
        // console.log(this.state)
        return (
            <div className="wrapper">
                <AdminLeftMenu />
                <div className="main">
                    <AdminHeader />
                    {this.state.isLoading && <Spining />}
                    <main className="content">
                        <div className="container-fluid p-0">
                            <div className="row mb-2 mb-xl-3">
                                <div className="col-auto d-none d-sm-block">
                                    <h3><strong> Transaction </strong> History </h3>
                                </div>
                            </div>

                            <div className="pl-2 pr-2">
                                {
                                    this.state.successMessage ?
                                        <div className={this.state.bgColor} role="alert">
                                            <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                                <span aria-hidden="true">×</span>
                                            </button>
                                            <div className="">
                                                {this.state.errorMessage}
                                            </div>
                                        </div>
                                        :
                                        null
                                }

                            </div>

                            <div className="row">
                                <div className="col-12 col-lg-12 col-xxl-12 d-flex">
                                    <div className="card flex-fill">

                                        <div className="card-body">

                                            <div className="filter-option">

                                                <h6 className="card-subtitle text-muted">Filter </h6>

                                                <div className="row">
                                                    <div className="col-md-4 mb-3">
                                                        <div className="input-group mb-2 mr-sm-2">
                                                            <div className="input-group-text"><FontAwesomeIcon icon={faSearch} /></div>
                                                            <input type="text" onChange={(event) => { this.setState({ serchData: event.target.value }) }} placeholder="Enter User Name  " className="form-control" />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4">
                                                        <div className="input-group mb-2 mr-sm-2">
                                                            <div className="input-group-text d-flex align-items-center justify-content-center" style={{ width: '40px' }}>
                                                                <FontAwesomeIcon icon={faCalendarAlt} />
                                                            </div>
                                                            <DatePicker
                                                                className="form-control"
                                                                dateFormat="yyyy/MM/dd"
                                                                value={this.state.dateFrom}
                                                                onChange={this.dateFrom}
                                                                selected={this.state.SelecteddateFrom}
                                                                placeholderText="From Date"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4 ">
                                                        <div className="input-group mb-2 mr-sm-2 d-flex">
                                                            <div className="input-group-text d-flex align-items-center justify-content-center" style={{ width: '40px' }}>
                                                                <FontAwesomeIcon icon={faCalendarAlt} />
                                                            </div>
                                                            <DatePicker
                                                                className="form-control"
                                                                dateFormat="yyyy/MM/dd"
                                                                value={this.state.dateTo}
                                                                onChange={this.dateTo}
                                                                selected={this.state.SelecteddateTo}
                                                                placeholderText="Date To"
                                                            />
                                                        </div>
                                                    </div>

                                                </div>
                                                {/* <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="input-group mb-2 mr-sm-2">
                                                            <div className="input-group-text"><FontAwesomeIcon icon={faCalendarAlt} /></div>
                                                            <DatePicker className="form-control btn-block"
                                                                dateFormat="yyyy/MM/dd"
                                                                value={this.state.dateFrom}
                                                                onChange={this.dateFrom}
                                                                selected={this.state.SelecteddateFrom}
                                                                placeholderText='From Date'
                                                            />

                                                        </div>
                                                    </div>

                                                    <div className="col-md-4">
                                                        <div className="input-group mb-2 mr-sm-2">
                                                            <div className="input-group-text"><FontAwesomeIcon icon={faCalendarAlt} /></div>
                                                            <DatePicker className="form-control btn-block"
                                                                dateFormat="yyyy/MM/dd"
                                                                value={this.state.dateTo}
                                                                onChange={this.dateTo}
                                                                selected={this.state.SelecteddateTo}
                                                                placeholderText='Date To'
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 text-right">
                                                        <div className="input-group mb-2 mr-sm-2">
                                                            <input type="button" onClick={() => this.searchWithDate()} value="Search With Date Only" className="btn mt-1  btn-primary btn-block btn-sm ml-auto" />
                                                        </div>
                                                    </div>
                                                </div> */}
                                                <div className="row justify-content-end">
                                                    <div className="col-md-3">
                                                        <div className="input-group mb-2">
                                                            <input
                                                                type="button"
                                                                onClick={() => this.showPagesOption()}
                                                                value="Search"
                                                                className="btn mt-1 btn-primary btn-block btn-sm"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>




                                            {this.state.allTransactionList ?
                                                <>
                                                    <div style={{ height: '800px', overflowY: 'auto' }} className="table-responsive">
                                                        <table className="table table-hover table-bordered align-middle">
                                                            <thead className="table-light sticky-top">
                                                                <tr>
                                                                    <th style={{ color: "white" }}>ID</th>
                                                                    <th style={{ width: '100px', color: "white" }}>Amount</th>
                                                                    <th style={{ color: "white" }}>Transaction Type</th>
                                                                    <th style={{ color: "white" }}>Initiated By</th>
                                                                    <th style={{ color: "white" }}>Remark</th>
                                                                    <th style={{ width: '550px', color: "white" }}>Description</th>
                                                                    <th style={{ color: "white" }}>Transaction ID</th>
                                                                    <th style={{ color: "white" }}>Gateway Req ID</th>
                                                                    <th style={{ color: "white" }}>Status</th>
                                                                    <th style={{ color: "white" }}>Created Date / Time</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {this.state.allTransactionList.map((item, i) => (
                                                                    <tr key={i}>
                                                                        <td>{item.id}</td>
                                                                        <td className="text-primary fw-bold text-end">{item.amount}</td>
                                                                        <td>
                                                                            <span className={`badge ${item.trans_type === 'credit' ? 'bg-success' : 'bg-danger'}`}>
                                                                                {item.trans_type}
                                                                            </span>
                                                                        </td>
                                                                        <td>{item.other_username} {item.other_user_id === 0 ? "System" : `(${item.other_user_id})`}</td>
                                                                        <td>{item.remark}</td>
                                                                        <td>{item.description}</td>
                                                                        <td>{item.transaction_id}</td>
                                                                        <td>{item.gateway_req_id}</td>
                                                                        <td>
                                                                            <span className={`badge ${item.status === 1 ? 'bg-success' : 'bg-danger'}`}>
                                                                                {item.status === 1 ? 'Success' : 'Failed'}
                                                                            </span>
                                                                        </td>
                                                                        <td>{this.formatToLocalDate(item.created)}</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                    {!this.state.showPages && (
                                                        <div className="row mt-2 align-items-center">
                                                            <div className="col-4 text-left">
                                                                <button
                                                                    type="button"
                                                                    disabled={this.state.page === 1}
                                                                    onClick={this.previousPage}
                                                                    className="btn btn-sm"
                                                                    style={{ backgroundColor: "#4ec9b0", color: "white" }}
                                                                >
                                                                    Previous
                                                                </button>
                                                            </div>
                                                            <div className="col-4 text-center">
                                                                <span style={{ fontSize: "13px" }} className="mr-3">...Page No: {this.state.page}</span>
                                                                <span style={{ fontSize: "13px" }}>Total Pages: {this.state.totalPages}...</span>
                                                            </div>
                                                            <div className="col-4 text-right">
                                                                <button
                                                                    type="button"
                                                                    onClick={this.nextPage}
                                                                    className="btn btn-sm"
                                                                    disabled={this.state.page === this.state.totalPages}
                                                                    style={{ backgroundColor: "#4ec9b0", color: "white" }}
                                                                >
                                                                    Next
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}

                                                </>
                                                :
                                                <div className="text-center">
                                                    <div className="card-body">
                                                        <img alt="Empty Data" className="project-empty-img" src={EmptyImg} />
                                                        <p> No Any Record Found </p>
                                                    </div>
                                                </div>
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                    <AdminFooter />
                </div>
            </div>

        );
    }
}
export default ResellerTransactionHistory;